
import {Component, Prop, Vue} from 'vue-property-decorator';
import hideMenuBar from '@/lib/hideMenuBar.ts';
import HeaderBar from '@/components/HeaderBar.vue';

@Component({
  components: {HeaderBar,}
})
export default class Layout extends Vue {
  // 由动态外部参数 获取 类样式
  @Prop(String) ['classPrefix']: string;
  @Prop(String) headerTitle!: string;
  @Prop(Boolean) titleIcon!: boolean;
  @Prop(String) routerPath!: string;

  mounted() {
    window.onload = () => {
      hideMenuBar();
    };
  }
}
